var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid mt-3"},[_c('b-breadcrumb',{class:_vm.$route.name.includes('reports-') ? 'breadcrumb-resized' : '',attrs:{"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }